import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';

import { ReplaySubject } from 'rxjs';

import { BaseNestedFieldDefinition } from '../../../../../core/field-definitions/entities/field-definition.entity';
import { ExtendedBaseProfileField } from '../../../../../core/profiles/entities/extended-profile-field.entity';
import { PartialRecord } from '../../../../../core/records/entities/partial-record.class';
import { FieldReadHelper } from '../../../../helpers/fields/field-read.helper';
import { ShSearchRoutingService } from '../../../../services/search-routing.service';
import { ShSimpleReadonlyFieldComponent } from '../simple-readonly-field/simple-readonly-field.component';

@Component({
    standalone: false,
    selector: 'sh-boolean-readonly-field',
    templateUrl: './boolean-readonly-field.component.html',
    styleUrls: ['../../base-generic-readonly-field/base-generic-readonly-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShBooleanReadonlyFieldComponent extends ShSimpleReadonlyFieldComponent implements OnDestroy {
    public icon$: ReplaySubject<string> = new ReplaySubject<string>(1);

    constructor(
        protected fieldHelper: FieldReadHelper,
        protected searchRoutingService: ShSearchRoutingService
    ) {
        super(fieldHelper, searchRoutingService);
    }

    init(profileField: ExtendedBaseProfileField, record: PartialRecord): void {
        const value: boolean | null = this.fieldHelper.getBooleanFieldValue(
            profileField.FieldDefinition as BaseNestedFieldDefinition,
            record
        );

        const icon: string = value ? 'check' : 'close';
        this.value$.next(value);
        this.icon$.next(icon);
    }

    ngOnDestroy() {
        this.icon$.complete();

        super.ngOnDestroy();
    }
}
